<template>
  <div v-if="missing.length">
    <h2 class="popup-message-title">{{ $t('participation.missing_terms.title') }}</h2>
    <p>{{ $t('participation.missing_terms.header') }}</p>
    <form class="basicForm termForm">
      <div class="form-row" v-for="term in missing" :key="term.uuid">
        <div class="form-item form-item-100 checkbox-radiobutton checkboxtable">
          <input :value="term.uuid" v-model="agreed" type="checkbox" class="form-check-input" :id="term.uuid" required>
          <div class="label">
            <label :for="term.uuid" v-html="term.checkbox_text"/>
            <div v-if="term.full_text">
              <a v-if="showFull[term.uuid]" @click.prevent="toggleFullText(term.uuid)" class="termFullToggle" >
                {{ $t('participation.missing_terms.btn_hide_full_text') }}
              </a>
              <a v-else @click.prevent="toggleFullText(term.uuid)" class="termFullToggle">
                {{ $t('participation.missing_terms.btn_show_full_text') }}
              </a>
            </div>
            <div v-if="showFull[term.uuid]" class="termDetail" v-html="term.full_text" />
          </div>
        </div>
      </div>

      <div id="submitOrBusy" class="form-submit">
        <button class="btn-primary" v-if="axiosBusy" disabled>
          <span class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true" />{{ $t('form.generic.btn_spinner') }}</button>
        <button class="btn-primary" v-else-if="!all_valid" disabled>
          {{ $t('participation.missing_terms.btn_form_invalid') }}
        </button>
        <button class="btn-primary" v-else
          v-on:click.prevent="agreeTerms()" >{{ $t('form.generic.btn_save') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  getTerm,
  agreeTerm
} from "@/api/terms.js";
import { mapGetters } from "vuex";

export default {
  name: 'Terms',
  props: {
    missingTermIdents: Array,
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
    all_valid() {
      return this.missing.length == this.agreed.length ? true : false;
    }
  },
  data() {
    return {
      missing: [],
      agreed: [],
      showFull: {},
    };
  },
  created() {
    this.fetchData()
  },
  watch: {
    missingTermIdents() {
      this.fetchData()
    }
  },
  methods: {
    toggleFullText(ident) {
      this.$set(this.showFull, ident, ! this.showFull[ident]);
    },
    async fetchData() {
      this.missing = [];
      this.missingTermIdents.forEach( async ident =>  {
        const rv = await getTerm(this.$userClient, ident);
        this.missing.push(rv.term);
        this.$set(this.showFull, rv.term.uuid, false);
      });
    },
    async agreeTerms() {
      this.agreed.forEach( async ident =>  {
        await agreeTerm(this.$userClient, ident);
      });

      await this.$frontendClient({
        url: "set-agreed-terms",
        method: "post",
      });

      var that=this;
      setTimeout(function() {
        that.$emit('terms-agreed');
      }, 300);
    }
  }
}
</script>
